import { render, staticRenderFns } from "./adjust.vue?vue&type=template&id=130c0e3a&scoped=true&"
import script from "./adjust.vue?vue&type=script&lang=js&"
export * from "./adjust.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130c0e3a",
  null
  
)

export default component.exports